"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ActiveTool;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _contexts = require("./contexts");

var _TinymceEditor = require("../TinymceEditor");

var _LinkPopover = _interopRequireDefault(require("../TinymceEditor/LinkPopover"));

var _constants = require("./constants");

var _previous = _interopRequireDefault(require("../../hooks/previous"));

var _context = require("../TinymceEditor/context");

var BoldButton = _TinymceEditor.buttons.BoldButton,
    ItalicButton = _TinymceEditor.buttons.ItalicButton,
    UnderlineButton = _TinymceEditor.buttons.UnderlineButton,
    StrikethroughButton = _TinymceEditor.buttons.StrikethroughButton,
    HighlightButton = _TinymceEditor.buttons.HighlightButton,
    RemoveFormatButton = _TinymceEditor.buttons.RemoveFormatButton,
    BulletListButton = _TinymceEditor.buttons.BulletListButton,
    OrderListButton = _TinymceEditor.buttons.OrderListButton,
    IndentMoreButton = _TinymceEditor.buttons.IndentMoreButton,
    IndentLessButton = _TinymceEditor.buttons.IndentLessButton,
    SizeButton = _TinymceEditor.buttons.SizeButton,
    TextColorButton = _TinymceEditor.buttons.TextColorButton;
var buttonComponents = [BoldButton, ItalicButton, UnderlineButton, StrikethroughButton, TextColorButton, HighlightButton, SizeButton, OrderListButton, BulletListButton, IndentMoreButton, IndentLessButton, RemoveFormatButton];

var FormatingBar = function FormatingBar(_ref) {
  var appearanceMode = _ref.appearanceMode;
  var focusedRef = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      tabIndex = _useState2[0],
      setTabIndex = _useState2[1];

  var initialedRef = (0, _react.useRef)(false);
  var buttonsRef = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    if (!initialedRef.current) {
      initialedRef.current = true;
      return;
    }

    buttonsRef.current[tabIndex].focus();
  }, [tabIndex]);

  var handleKeyDown = function handleKeyDown(e) {
    if (!focusedRef.current) return;
    e.stopPropagation();

    if (e.key === 'ArrowLeft') {
      setTabIndex(function (item) {
        return Math.max(item - 1, 0);
      });
    } else if (e.key === 'ArrowRight') {
      setTabIndex(function (item) {
        return Math.min(item + 1, buttonComponents.length - 1);
      });
    }
  };

  var handleFocus = function handleFocus() {
    focusedRef.current = true;
  };

  var handleBlur = function handleBlur() {
    focusedRef.current = false;
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-light shadow dark:shadow-shallow rounded bg-card Compose-formatting inline-flex py-1 px-2",
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, buttonComponents.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(item, {
      ref: function ref(item) {
        return buttonsRef.current[index] = item;
      },
      appearanceMode: appearanceMode,
      tabIndex: tabIndex === index ? '0' : '-1',
      key: index
    });
  }));
};

function ActiveTool(_ref2) {
  var appearanceMode = _ref2.appearanceMode;
  var editor = (0, _context.useEditor)();

  var _useContext = (0, _react.useContext)(_contexts.ActiveToolContext),
      activeTool = _useContext.activeTool,
      setActiveTool = _useContext.setActiveTool,
      linkDialogRef = _useContext.linkDialogRef;

  var previousActiveTool = (0, _previous["default"])(activeTool);
  (0, _react.useEffect)(function () {
    activeTool === _constants.TOOL_LINK ? linkDialogRef.current.show() : linkDialogRef.current.hide();
  }, [activeTool]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: activeTool === _constants.TOOL_NONE ? '' : 'pb-4 px-4'
  }, activeTool === _constants.TOOL_FORMATTING && !!editor && /*#__PURE__*/_react["default"].createElement(FormatingBar, {
    appearanceMode: appearanceMode
  }), /*#__PURE__*/_react["default"].createElement(_LinkPopover["default"], {
    ref: linkDialogRef,
    onOpen: function onOpen() {
      return setActiveTool(_constants.TOOL_LINK);
    },
    onHidden: function onHidden() {
      setActiveTool(previousActiveTool === _constants.TOOL_FORMATTING ? _constants.TOOL_FORMATTING : _constants.TOOL_NONE);
    }
  }));
}
//# sourceMappingURL=ActiveTool.js.map